/** laravel api */
export const OAUTH_AUTH_URL = `${process.env.NEXT_PUBLIC_AUTH_API?.replace("/v1", "")}/oauth/authorize`;
export const OAUTH_TOKEN_URL = `${process.env.NEXT_PUBLIC_AUTH_API?.replace("/v1", "")}/oauth/token`;
export const OAUTH_USERINFO_URL = `${process.env.NEXT_PUBLIC_AUTH_API}/auth/me`;

/** Next api */
export const REFRESH_TOKEN_URL = `${process.env.NEXT_PUBLIC_INTERNAL_API_URL}/token/refresh`;
